import React, { useState } from 'react';
import { Divider, Select } from 'antd';
import { observer } from 'mobx-react';
import { LabeledValue, SelectProps, SelectValue } from 'antd/es/select';
import Suggestion from '../Suggestion';
import { FinishesProps } from '@partsbadger/types';
import QuoteStore from '../../stores/QuoteStore';

interface Props extends SelectProps {
    finishes: Array<FinishesProps>;
    suggestions?: {
        id: number;
        name: string;
        thumbnail: string;
    }[];
    value?: LabeledValue | null;
    for_staff?: boolean;
}

export const Finishes = observer((props: Props) => {
    const [isDropDownMenuOpen, setIsDropDownMenuOpen] = useState(false);

    let data = props.finishes;

    if (QuoteStore?.quote?.contact?.is_hobbyist) {
        data = data?.filter(item => {
            return item.name !== 'Review 2D';
        });
    }

    // Get Custom Option
    const custom = data.find(item => item.name === 'Custom');

    // Exclude custom from list
    const items = data.filter(item => item.id !== custom?.id);

    const menu = items.map(item => {
        return <Select.Option key={item.id}>{item.name}</Select.Option>;
    });

    const EmptyTag = (
        <div
            className="flex flex-no-wrap cursor-pointer"
            onClick={() => {
                if (custom && props.onChange) {
                    const val: SelectValue = {
                        key: custom.id.toString(),
                        label: custom.name,
                        value: custom.id.toString(),
                    };
                    props.onChange(val, []);
                    setIsDropDownMenuOpen(false);
                }
            }}
        >
            <span className="flex flex-row items-center cursor-pointer text-light">
                Can&apos;t find your Surface Finish? Choose <span className="text-primary link">Custom</span>
            </span>
        </div>
    );

    return (
        <>
            <Select
                size={props?.for_staff ? 'middle' : 'small'}
                showSearch
                labelInValue
                bordered={true}
                dropdownMatchSelectWidth={false}
                placeholder="Select"
                data-testid="finish-select"
                {...props}
                open={isDropDownMenuOpen}
                onDropdownVisibleChange={visible => setIsDropDownMenuOpen(visible)}
                notFoundContent={EmptyTag}
                allowClear={false}
                filterOption={(input, option: any) => {
                    try {
                        if (!option.key) {
                            // Filter by group label
                            return option.props?.label?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
                        }

                        return option.props?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
                    } catch (e) {
                        return false;
                    }
                }}
                dropdownRender={menu => (
                    <div>
                        {menu}
                        <Divider style={{ margin: '4px 0' }} />
                        {/*<div className="flex flex-no-wrap p-2 cursor-pointer"*/}
                        {/*     onClick={() => {*/}
                        {/*         props.onChange({*/}
                        {/*             key: custom.id,*/}
                        {/*             label: custom.name*/}
                        {/*         })*/}
                        {/*     }}*/}
                        {/*>*/}
                        {/*    <span className="flex flex-row items-center cursor-pointer justify-center link">*/}
                        {/*        <Icon type={"plus"}/>*/}
                        {/*        <div className="ml-2">Custom</div>*/}
                        {/*    </span>*/}
                        {/*</div>*/}
                    </div>
                )}
            >
                {!QuoteStore?.quote?.contact?.is_hobbyist && custom && custom?.id > 0 && (
                    <Select.OptGroup label={'Custom'}>
                        <Select.Option key={custom.id}>{custom.name}</Select.Option>
                    </Select.OptGroup>
                )}
                <Select.OptGroup label={'Options'}>{menu}</Select.OptGroup>
            </Select>

            {!props.value?.label && (
                <div className="overflow-auto" style={{ maxHeight: '75px' }}>
                    {props.suggestions?.map(suggestion => (
                        <Suggestion
                            key={suggestion.id}
                            title={suggestion.name}
                            thumbnail={suggestion.thumbnail}
                            handleClick={() => {
                                const val = {
                                    key: suggestion.id.toString(),
                                    label: suggestion.name,
                                    value: suggestion.id.toString(),
                                };

                                if (props.onSelect) {
                                    props.onSelect(val, val);
                                }

                                if (props.onChange) {
                                    props.onChange(val, []);
                                }
                            }}
                        />
                    ))}
                </div>
            )}
        </>
    );
});
